// next-app/src/lib/validations/eligibility.ts
import { z } from 'zod';
import {
  emailSchema,
  phoneSchema,
  taxIdSchema,
  address1Schema,
  citySchema,
  zipSchema,
  nameSchema,
  requiredSchema,
  requiredBooleanSchema,
  requiredDateSchema,
} from './validators';

// ============================================
// ELIGIBILITY FORM (Event Request)
// Reference: src/pages/EligibilityForm.tsx
// ============================================

export const eligibilityFormSchema = z.object({
  // Charity Information
  name: requiredSchema.max(100),
  website: requiredSchema.max(255),
  tax_id: taxIdSchema,
  contact_first_name: nameSchema.max(45),
  contact_last_name: nameSchema.max(45),
  contact_phone_number: phoneSchema,
  contact_email: emailSchema.max(100),
  funding_purpose: requiredSchema.max(1000),

  // Event Date
  start_date: requiredDateSchema,

  // Location
  event_location_name: requiredSchema.max(255),
  address_1: address1Schema.max(45),
  city: citySchema.max(45),
  state: requiredSchema,
  postal_code: zipSchema,

  // Terms Agreement
  agree_terms: requiredBooleanSchema,
});

export type EligibilityFormData = z.infer<typeof eligibilityFormSchema>;
